<!-- eslint-disable -->
<template>
    <div class="page-content">
      <section class="row">
        <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h3 class="card-title text-dark text-left">A. MOBILE BANKING BANK LAIN </h3>
                <ol class="card-text text-dark">
                  <li>Login</li>
                  <li>Pilih menu <strong>Transfer</strong></li>
                  <li>Pilih bank Tujuan ke <strong>BSI atau Bank Muamalat (pilih salah satu)</strong></li>
                  <li>
                    Isi No Rekening tujuan dengan nomor Virtual Account siswa : <br>
                    <strong>Virtual Account Bank BSI ex BSM : </strong>{{ '9009129'+this.dataSiswa.nis }} <br>
                    <strong>Virtual Account Bank BSI ex BRIS : </strong> {{ '9009457'+this.dataSiswa.nis }} <br>
                    <strong>Virtual Account Bank Muamalat : </strong>{{ '8571680000'+this.dataSiswa.nis }}
                    
                  </li>
                 <li>
                    Isi Nominal Transfer dengan Total pembayaran masing-masing siswa ditambah admin Bank (Nominal dibawah sudah ditambahkan admin bank) : <br>
                    <strong>Transfer ke Bank BSI ex BSM : Rp. {{ $filters.currencyUSD(tagihanBSM) }}</strong><br>
                    <strong>Transfer ke Bank Muamalat : Rp. {{ $filters.currencyUSD(tagihanBMI) }}</strong> <br>
                    <strong>Transfer ke Bank BSI ex BRIS : Rp. {{ $filters.currencyUSD(tagihanBSM) }}</strong>
                  </li>
                  <li>Mohon untuk dicek kembali nama penerima yang muncul apakah sudah sesuai dengan nama siswa yang akan dibayarkan</li>
                  <li>Lanjutkan ke proses Pembayaran </li>
                </ol>

              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="row">
        <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h3 class="card-title text-dark text-left">B. ATM BANK LAIN </h3>
                <ol class="card-text text-dark">
                  <li>Login</li>
                  <li>Pilih menu <strong>Transfer</strong></li>
                  <li>Pilih bank Tujuan ke <strong>BSI atau Bank Muamalat (pilih salah satu)</strong></li>
                  <li>
                    Isi No Rekening tujuan dengan nomor Virtual Account siswa : <br>
                    <strong>Virtual Account Bank BSI ex BSM : </strong>{{ '4519009129'+this.dataSiswa.nis }}  &nbsp; &nbsp; &nbsp;&nbsp; <i><small class="text-danger">Ket. 451 : tiga digit awal adalah kode bank</small></i><br>
                    <strong>Virtual Account Bank BSI ex BRIS : </strong>{{ '4519009457'+this.dataSiswa.nis }} &nbsp; &nbsp; &nbsp; <i><small class="text-danger">Ket. 451 : tiga digit awal adalah kode bank</small></i><br>
                    <strong>Virtual Account Bank Muamalat : </strong>{{ '1478571680000'+this.dataSiswa.nis }} &nbsp; <i> <small class="text-danger">Ket. 147 : tiga digit awal adalah kode bank</small></i>
                    
                  </li>
                 <li>
                    Isi Nominal Transfer dengan Total pembayaran masing-masing siswa ditambah admin Bank (Nominal dibawah sudah ditambahkan admin bank): <br>
                    <strong>Transfer ke Bank BSI ex BSM : Rp. {{ $filters.currencyUSD(tagihanBSM) }} </strong> <br>
                    <strong>Transfer ke Bank Muamalat : Rp. {{ $filters.currencyUSD(tagihanBMI) }} </strong> <br>
                    <strong>Transfer ke Bank BSI ex BRIS : Rp. {{ $filters.currencyUSD(tagihanBSM) }}</strong>
                  </li>
                  <li>Mohon untuk dicek kembali nama penerima yang muncul apakah sudah sesuai dengan nama siswa yang akan dibayarkan</li>
                  <li>Lanjutkan ke proses Pembayaran </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="row">
        <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body bg-blue-new">
                <h3 class="card-title text-dark text-left">CATATAN </h3>
                <ol class="card-text text-dark">
                  <!--<li>Jika nominal BPP siswa <strong>Rp. 715.000</strong> maka nominal transfer yang dimasukkan untuk : Bank BSI = <strong>Rp. 717.000</strong> dan Bank BMI = <strong>Rp. 718.000</strong></li>-->
                  <li><strong>Nama Penerima Bank BSI ex BSM </strong> : <strong>{{ this.dataSiswa.nama }}/{{ '0'+tagihanBSM }}</strong>, perlu diketahui bahwa angka yang muncul di samping nama siswa adalah total tagihan yang harus dibayar, maka untuk nominal transfer yang dimasukkan harus disesuaikan kembali dengan nominal yang ditagihkan oleh Bank.</li>
                  <li><strong>Nama Penerima Bank BSI ex BRIS </strong> : <strong>{{ this.dataSiswa.nama }}/{{ '0'+tagihanBSM }}</strong>, perlu diketahui bahwa angka yang muncul di samping nama siswa adalah total tagihan yang harus dibayar, maka untuk nominal transfer yang dimasukkan harus disesuaikan kembali dengan nominal yang ditagihkan oleh Bank.</li>
                  <li><strong>Nama Penerima Bank Muamalat </strong> : <strong>{{ this.dataSiswa.nama }}/{{ '0'+tagihanBMI }}</strong>, perlu diketahui bahwa angka yang muncul di samping nama siswa adalah total tagihan yang harus dibayar, maka untuk nominal transfer yang dimasukkan harus disesuaikan kembali dengan nominal yang ditagihkan oleh Bank.</li>
                  
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>
<!-- eslint-disable -->
<script>
export default {
  name: "PetunjukBankLain",
  props: {
    dataSiswa: {},
    tagihanBMI : 0,
    tagihanBSM : 0
  }
};
</script>